
import {Box, ResultSubject, Span, Text} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import OfficeIcon from './OfficeIcon';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';

const TeamsSnippet = ({ item }:any) => {
  let teamAndChannel = item.teamDisplayName ? `@${item.teamDisplayName}, ` : ''
  if (!item.channelDisplayName) {
    if (item.from?.user?.displayName) {
      teamAndChannel = `${teamAndChannel}${item.sender}`
    }
  } else {
    teamAndChannel = `${teamAndChannel}#${item.channelDisplayName}`
  }
  return (
    <>
      <ResultSubject>
        <Span>From: </Span>
        <HighlightMarker>{item.sender}</HighlightMarker>
        <Box width={30} display="inline-block">
          <OfficeIcon type="teams" />
        </Box>
      </ResultSubject>
      <HighlightMarker>
        <Text>
          {item.resultSnippet}
        </Text>
      </HighlightMarker>
      <FileAttachments files={item.att} />
      <Text variant="muted" size="small" >
        {`${item.account} | ${teamAndChannel} | ${item.date}`}
      </Text>
    </>
  )
}

export default TeamsSnippet;